module.exports = __webpack_public_path__ + "static/media/Huis-4-4.0bcec0f8.jpg";